export const TITULO_PAGINA = 'Dados de Pagamento'

export const TEXTO_MODAL_EXCLUSAO_CARTAO = 'Você tem certeza que deseja excluir este cartão?'

export const TITULO_ADICIONAR_CARTAO = 'Adicionar cartão de crédito'

export const MODAL_CANCELAR = 'Cancelar'

export const MODAL_CONFIRMAR = 'Confirmar'

export const TITULO_ERRO_SALVAR_CARTAO_CREDITO = 'Sua transação foi recusada.'

